import { j as d } from "./jsx-runtime-B6kdoens.js";
import { c as h } from "./index-CROKJrb5.js";
import { c as M, f as b } from "./create-component-CBAeEoQ6.js";
import { createContext as x, useContext as A } from "react";
import { a as g } from "./vanilla-CSAfDK5R.js";
import { u as v } from "./NavigationState-EOPjgMu1.js";
import { u as N, a as w } from "./react-B_GApDuV.js";
const T = () => ({
  depthAtom: g(0)
}), E = x(
  T()
), q = () => A(E), C = h({
  base: "cur-flex cur-w-full cur-text-left cur-items-center cur-gap-2",
  variants: {
    depthEqualsOne: {
      true: "cur-border-t cur-font-bold cur-py-3"
    },
    depthEqualsTwo: {
      true: "cur-text-brand cur-font-bold"
    },
    depthGreaterThanTwo: {
      true: "cur-py-2"
    }
  }
}), R = M(
  "NavigationMobileMenuLink",
  b(
    ({ as: o, className: a, closeOnClick: s = !0, onClick: t, title: r, ...n }, u) => {
      const { depthAtom: i } = q(), e = N(i), { isMobileMenuOpenAtom: m } = v(), c = w(m), p = C({
        depthEqualsOne: e === 1,
        depthEqualsTwo: e === 2,
        depthGreaterThanTwo: e > 2,
        className: a
      }), l = o || "a";
      return /* @__PURE__ */ d.jsx(
        l,
        {
          className: p,
          ref: u,
          onClick: (f) => {
            s && c(!1), t == null || t(f);
          },
          ...n,
          children: r
        }
      );
    }
  )
);
export {
  R as N,
  E as a,
  T as c,
  q as u
};
//# sourceMappingURL=index-g4ls63IB.js.map
